import React, {useEffect, useState} from "react";
import Modal from "@ui-components/Modal";
import Alert from "@ui-components/Alert";
import {useIntl} from "react-intl";
import { DisassociateModalProps } from "./types";
import Button from "@ui-components/Button";
import { UserWithRoleSchema } from "feature/types";

/**
 * This modal is used to disassociate a user from a specific user_account.
 * It cannot change the chosen user.
 * @param DisassociateModalProps 
 * @returns 
 */
export const DisassociateUserModal = ({
  chosenUser,
  onConfirm,
  onCancel,
}: DisassociateModalProps) => {
  const intl = useIntl();
  const [loading, setLoading] = useState(false);
  return (
    <Modal onExit={onCancel}>
      <div className={"p-5 grid grid-col gap-y-5"}>
        <Alert
          type={"warning"}
          text={
            chosenUser === 'self' ? intl.formatMessage({
              id: "warning_disassociate_self",
              defaultMessage: "Attenzione, ti stai disassociando dall'organizzazione di cui fai parte",
            }) :intl.formatMessage({
              id: "warning_disassociate_user",
              defaultMessage: "Attenzione, l'utente non farà più parte della tua organizzazione",
            })
          }
        />
        <div>
          {chosenUser === 'self' ?
            <p>
              {intl.formatMessage({
                id: "disassociate_self",
                defaultMessage: `Sei sicuro di volerti disassociare?`,
              })}
            </p> :
            <p>
              {intl.formatMessage({
                id: "disassociate_user",
                defaultMessage: `Sei sicuro di voler disassociare l'utente selezionato da questo account?`,
              })}
            </p>
          }
        </div>
        <div className={"flex w-full justify-center gap-x-2 "}>
          <Button
            onClick={async () => {
              setLoading(true);
              await onConfirm();
              setLoading(false);
            }}
            disabled={!chosenUser}
            submitting={loading}
          >
            {intl.formatMessage({
              id: "confirm",
              defaultMessage: "Conferma",
            })}
          </Button>
          <Button onClick={onCancel} styleType={"empty"}>
            {intl.formatMessage({
              id: "cancel",
              defaultMessage: "Annulla",
            })}
          </Button>
        </div>
      </div>
    </Modal>
  );
};